import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.beforeCache = () => this.reset()
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.reset()
  }

  open(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    const modal = document.getElementById("conversation-recovery-modal")
    const controller = modal && this.application.getControllerForElementAndIdentifier(modal, "modal")
    if (!controller) return
    event.preventDefault()
    event.stopPropagation()
    this.reset()
    this.modal = modal
    this.frame = modal.querySelector('[data-recovery-issuance-frame]')
    this.frame.src = this.element.href
    this.observer = new MutationObserver(() => {
      if (modal.dataset.modalOpenValue === "false") this.reset()
    })
    this.observer.observe(modal, { attributes: true, attributeFilter: ["data-modal-open-value"] })
    this.onMessage = (message) => {
      if (message.origin === location.origin && message.source === this.frame?.contentWindow && message.data?.type === "recovery:close") controller.close()
    }
    window.addEventListener("message", this.onMessage)
    controller.open()
  }

  reset() {
    this.observer?.disconnect()
    if (this.onMessage) window.removeEventListener("message", this.onMessage)
    if (this.frame) this.frame.src = "about:blank"
    this.frame = null
    this.modal = null
  }
}
